import React from "react";
import apiService from "../../APIService";
import cometdLib from "cometd";

const MessageA80 = (props) => {
  console.log("props in A80", props);
  let textData =
    props.item && props.item.text_data && JSON.stringify(props.item.text_data);
  const code = props.item && props.item.code;
  let TSAgentServerUrl = "https://chat.tataplay.com/genesys/cometd";
  // let TSAgentServerUrl="https://devdata.simplify360.com/bmcometd/cometd"
  let TSAgentChatChannel = "/service/chatV2/customer-support";
  const data={
    "operation":"requestChat",
    "nickname":" Binit Thapa",
    "firstName":" Binit Thapa",
    "lastName":"",
    "subject":"11589916724 |3|Bengaluru|Karnataka|India|5/25/2021, 6:33:21 PM|2021-05-10",
    "userData":{
       "insertedID":"FAILURE ",
       "_provide_code":"false",
       "cti_flowname":"GBM",
       "cti_src":"GBM",
       "cti_first_name":" Binit Thapa",
       "FirstName":" Binit Thapa",
       "cti_last_name":"",
       "LastName":"",
       "cti_email_address":"binit@gmail.com ",
       "EmailAddress":"binit@gmail.com ",
       "cti_cust_cat":"MASS",
       "cti_SubscriberID":"11589916724 ",
       "cti_city":"Bengaluru",
       "cti_userFirstMessage":"1",
       "PhoneNumber":"09645842002",
       "IdentifyCreateContact":"3",
       "MediaType":"chat"
    }
  }
  let cometd = new cometdLib.CometD();
  cometd.configure({
    url: TSAgentServerUrl,
    channel:TSAgentChatChannel,
  });
  cometd.addListener(TSAgentChatChannel,function(m){
    console.log("REFRESH DATA",m)
  })
  cometd.websocketEnabled = false;
  cometd.unregisterTransport('websocket');
 
  var TimeStampExtension = require('cometd/TimeStampExtension');
 
  cometd.registerExtension('timestamp', new TimeStampExtension());
 console.log(TimeStampExtension,"TimeStampExtension")
  cometd.handshake(function(handshakeReply) {
  
    if (handshakeReply.successful) {
      console.log("HANDHSAKE SUCCESFULL",handshakeReply);
       
				cometd.batch(function()
			 {
				cometd.publish(TSAgentChatChannel,data,
				function(message) 
				{
					 console.log("PUBLISHED SUCCESSFULLY",message)
				},
				function(subscribeReply)
				{
					  console.log("PUBLISHED SUCCESSFULLY",subscribeReply)
				});
			});
			 
      /* Successful handshake */
       
     
    } 
    else 
    console.log("HANDHSAKE FAILED.");
  });

  return (
    <div className="s360-agent-container">
      <p>transfer initiated</p>
    </div>
  );
};

export default MessageA80;
